/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_SavedInputs */

const en_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings have been saved successfully.`)
};

const fr_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les paramètres ont été enregistrés avec succès.`)
};

const de_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Einstellungen wurden erfolgreich gespeichert.`)
};

const it_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le impostazioni sono state salvate correttamente.`)
};

const ru_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки успешно сохранены.`)
};

const es_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La configuración se ha guardado correctamente.`)
};

const zh_cn2_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置已成功保存。`)
};

const ja_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定が正常に保存されました。`)
};

const hi_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटिंग्स सफलतापूर्वक सहेज ली गई हैं।`)
};

const pt_pt2_options_cli_saved = /** @type {(inputs: Options_Cli_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As configurações foram salvas com sucesso.`)
};

/**
* | output |
* | --- |
* | "Settings have been saved successfully." |
*
* @param {Options_Cli_SavedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_saved = /** @type {((inputs?: Options_Cli_SavedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_SavedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_saved(inputs)
	if (locale === "de") return de_options_cli_saved(inputs)
	if (locale === "it") return it_options_cli_saved(inputs)
	if (locale === "ru") return ru_options_cli_saved(inputs)
	if (locale === "es") return es_options_cli_saved(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_saved(inputs)
	if (locale === "ja") return ja_options_cli_saved(inputs)
	if (locale === "hi") return hi_options_cli_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_saved(inputs)
	return en_options_cli_saved(inputs)
});